const PUBLIC_URL = process.env.PUBLIC_URL || '';

export const COOKIE_CONSENT_KEY = 'mishtameret-cookie-consent';
export const THEME_STORAGE_KEY = 'mishtameret-theme';

export const LOGO_SRC_LIGHT = `${PUBLIC_URL}/mishtameret-logo-light.png`;
export const LOGO_SRC_DARK = `${PUBLIC_URL}/mishtameret-logo-dark.png`;
export const LOGO_SRC = LOGO_SRC_LIGHT;

/** Cache-bust so theme switches always fetch the right asset */
export function logoUrlForMode(mode) {
  const src = mode === 'light' ? LOGO_SRC_LIGHT : LOGO_SRC_DARK;
  return `${src}?v=3`;
}

const shared = {
  fontDisplay: '"Heebo", "Segoe UI", sans-serif',
  fontBody: '"Heebo", "Segoe UI", sans-serif',
  radius: 14,
};

export const THEMES = {
  dark: {
    ...shared,
    mode: 'dark',
    logo: LOGO_SRC_DARK,
    htmlBg: '#141414',
    pageBg: `
      radial-gradient(ellipse at 50% 0%, rgba(210,180,140,0.12) 0%, transparent 50%),
      radial-gradient(ellipse at 100% 100%, rgba(80,60,40,0.2) 0%, transparent 45%),
      linear-gradient(180deg, #1a1a1a 0%, #0f0f0f 55%, #0a0a0a 100%)
    `,
    text: '#f3ebe0',
    textMuted: 'rgba(243,235,224,0.62)',
    accent: '#d4af7a',
    accentSoft: '#c4a06a',
    accentContrast: '#1a140c',
    surface: 'rgba(36,32,28,0.88)',
    surfaceHover: 'rgba(48,42,36,0.95)',
    border: 'rgba(212,175,122,0.28)',
    borderSoft: 'rgba(212,175,122,0.14)',
    navBg: 'rgba(18,16,14,0.94)',
    danger: '#e57373',
    success: '#81c784',
    shadow: '0 12px 40px rgba(0,0,0,0.45)',
    inputBg: 'rgba(0,0,0,0.35)',
  },
  light: {
    ...shared,
    mode: 'light',
    logo: LOGO_SRC_LIGHT,
    htmlBg: '#f7f2ea',
    pageBg: `
      radial-gradient(ellipse at 50% 0%, rgba(212,175,122,0.18) 0%, transparent 48%),
      linear-gradient(180deg, #fbf7f0 0%, #f0e8dc 100%)
    `,
    text: '#1f1a14',
    textMuted: 'rgba(31,26,20,0.58)',
    accent: '#a8864a',
    accentSoft: '#c4a06a',
    accentContrast: '#fffaf2',
    surface: 'rgba(255,252,247,0.92)',
    surfaceHover: 'rgba(255,255,255,0.98)',
    border: 'rgba(168,134,74,0.35)',
    borderSoft: 'rgba(168,134,74,0.16)',
    navBg: 'rgba(255,252,247,0.96)',
    danger: '#c62828',
    success: '#2e7d32',
    shadow: '0 10px 32px rgba(40,30,15,0.1)',
    inputBg: 'rgba(255,255,255,0.85)',
  },
};

export function getStoredThemeMode() {
  try {
    const v = localStorage.getItem(THEME_STORAGE_KEY);
    if (v === 'light' || v === 'dark') return v;
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
  }
  return 'dark';
}

export function persistThemeMode(mode) {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, mode);
  } catch {
    /* ignore */
  }
}

export function hasCookieConsent() {
  try {
    return localStorage.getItem(COOKIE_CONSENT_KEY) === 'accepted';
  } catch {
    return false;
  }
}

export function acceptCookieConsent() {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
  } catch {
    /* ignore */
  }
}

export function getTheme(mode) {
  const base = THEMES[mode === 'light' ? 'light' : 'dark'];
  return { ...base, logo: logoUrlForMode(base.mode) };
}
